import React, { Component } from 'react';
import ImageLoader from '../../../../components/ImageLoader';
import Truncate from 'react-truncate';
import { Button, OverlayTrigger, Popover } from 'react-bootstrap';
import SearchBarWrapper from '../../../../components/SearchBarWrapper';
import CategoryPodcastSkeletonLoader from '../../../../components/ui/skeleton/CategoryPodcastSkeletonLoader';

class DashboardSubscribedTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSearch: true
    };
  }

  render() {
    return (
      <div className="square-container">
        {this.props.fetchingPodcasts && <CategoryPodcastSkeletonLoader />}
        {!this.props.fetchingPodcasts && (
          <>
            {this.state.showSearch && (
              <>
                <SearchBarWrapper
                  onChange={this.props.search}
                  searchBar={this.props.searchBar}
                  onClick={this.props.sortPodcast}
                  addNew={false}
                  searchUi={this.props.searchUi}
                />
                <div style={{ display: 'inline' }}>
                  <Button
                    bsClass="login-btn button-oval button-cta2-24 button-add-rss"
                    onClick={this.props.podcastModal}
                  >
                    <i className="fa fa-rss" style={{ marginRight: '5px' }}></i>
                    <span>Add RSS</span>
                  </Button>
                </div>
              </>
            )}
            <div className="divider-line">
              <span className="cat-name">SIGNAL</span>{' '}
              {this.props.openMyProProp === 'block' ? (
                <i
                  className="fa fa-angle-down"
                  style={{ marginRight: '5px' }}
                  onClick={this.props.openMyPro}
                ></i>
              ) : (
                <i
                  className="fa fa-angle-up"
                  style={{ marginRight: '5px' }}
                  onClick={this.props.openMyPro}
                ></i>
              )}
            </div>
            <div style={{ display: this.props.openMyProProp }}>
              {(this.props.podcastsTab || []).map((p) =>
                (p.enterpriseType != null && p.enterpriseType === 1) ||
                (p.isOwner !== null && p.isOwner) ? (
                  <div
                    id={
                      this.props.decoration && this.props.id == p.id
                        ? 'decoration'
                        : ''
                    }
                    // {/* TILE FOR PRO CONTENT / SIGNAL SECTION */}
                    className="img-slider img-slider-width24"
                    style={{ width: '104px' }}
                    key={p.id}
                    data-toggle="tooltip"
                    data-placement="top"
                    onClick={() =>
                      this.props.reloadDocumentsAndFlags(
                        0,
                        p.id,
                        p.podcastId,
                        p.name,
                        p.imageUrl,
                        p.feedUrl,
                        p.artistName,
                        p.webPodcast,
                        false,
                        p.authScheme,
                        p.enterpriseType,
                        p.isOwner
                      )
                    }
                  >
                    {p.newDocumentsCount > 0 && (
                      <div className="new-documents-count">
                        <span>{p.newDocumentsCount}</span>
                      </div>
                    )}
                    <div className='glass-dashboard-tile'>
                    <div className="dashboard-podcast-name">
                      <OverlayTrigger
                        trigger={['hover', 'focus']}
                        placement="top"
                        overlay={<Popover id="popover-basic">{p.name}</Popover>}
                      >
                        <span>{p.newDocumentsCount ? `${p.newDocumentsCount} New` : ''}&nbsp;
                        <div className="dashboard-podcast-title">
                        <Truncate lines={2} ellipsis={'...'} width={150}>
                          {p.name}
                        </Truncate>
                        </div>
                        </span>
                      </OverlayTrigger>
                    </div>
                    </div>
                  </div>
                ) : (
                  ''
                )
              )}
            </div>
            <div className="divider-line" style={{ marginTop: 20 }}>
              <span className="cat-name">WORKSPACE</span>{' '}
              {this.props.openMyPodsProp === 'block' ? (
                <i
                  className="fa fa-angle-down"
                  style={{ marginRight: '5px' }}
                  onClick={this.props.openMyPods}
                ></i>
              ) : (
                <i
                  className="fa fa-angle-up"
                  style={{ marginRight: '5px' }}
                  onClick={this.props.openMyPods}
                ></i>
              )}
            </div>
             {/* TILE FOR NON-PRO CONTENT / WORKSPACE SECTION */}
            <div style={{ display: this.props.openMyPodsProp }}>
              {(this.props.podcastsTab || []).map((p) =>
                (p.enterpriseType === null || p.enterpriseType === 0) &&
                (p.isOwner === null || !p.isOwner) ? (
                  <div
                    id={
                      this.props.decoration && this.props.id == p.id
                        ? 'decoration'
                        : ''
                    }
                    className="img-slider img-slider-width24"
                    key={p.id}
                    data-toggle="tooltip"
                    data-placement="top"
                    onClick={() =>
                      this.props.reloadDocumentsAndFlags(
                        0,
                        p.id,
                        p.podcastId,
                        p.name,
                        p.imageUrl,
                        p.feedUrl,
                        p.artistName,
                        p.webPodcast,
                        false,
                        p.authScheme,
                        p.enterprise
                      )
                    }
                  >
                    {p.newDocumentsCount > 0 && (
                      <div className="new-documents-count">
                        <span>{p.newDocumentsCount}</span>
                      </div>
                    )}
                  
                    <div className='glass-dashboard-tile'>
                    <div className="dashboard-podcast-name">
                      <OverlayTrigger
                        trigger={['hover', 'focus']}
                        placement="top"
                        overlay={<Popover id="popover-basic">{p.name}</Popover>}
                      >
                        <span>&nbsp;
                        <div className="dashboard-podcast-title">
                       
                        <Truncate lines={2} ellipsis={'...'} width={150}>
                          {p.name}
                        </Truncate>
                        </div>
                        </span>
                      </OverlayTrigger>
                    </div>
                    </div>
                  </div>
                ) : (
                  ''
                )
              )}
            </div>
          </>
        )}
      </div>
    );
  }
}

export default DashboardSubscribedTab;
